"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromUtf8ToArray = fromUtf8ToArray;
exports.fromBufferToB64 = fromBufferToB64;
exports.fromBufferToUtf8 = fromBufferToUtf8;
exports.fromB64ToArray = fromB64ToArray;
function fromUtf8ToArray(str) {
    return new TextEncoder().encode(str);
}
function fromBufferToB64(buffer) {
    return Buffer.from(buffer).toString("base64");
}
function fromBufferToUtf8(buffer) {
    return new TextDecoder().decode(buffer);
}
function fromB64ToArray(str) {
    return Buffer.from(str, "base64");
}
//# sourceMappingURL=utils.js.map